import { useEffect, useState } from "react";
import { Button, Switch } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import http from "../../../../../../../bae-client/HTTP";
import DashboardModal from "../../modals/DashboardModal";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AlertDialog from "../../../../../../stylized/AlertDialog";
import Loader from "../../../../../../stylized/Loader";
import EmptyConfigComponent from "../EmptyConfigComponent";
import { convertUTCTimeToLocalTime } from "../../../../../../../bae-client/Utils";
import CustomSnackbar from "../../../../../../stylized/CustomSnackbar/CustomSnackbar";

export default function DashboardReportConfig({ setEmailModal, emailModal }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [alertDialogShow, setAlertDialogShow] = useState(false);
    const [alertDialogContent, setAlertDialogContent] = useState({
        title: "",
        message: "",
        isAlert: false,
        messageId: "",
        buttonId: "",
    });
    const [showLoader, setShowLoader] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [severity, setSeverity] = useState("");
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const open = Boolean(anchorEl);
    const [fromContactsMapData, setFromContactsMapData] = useState({});
    const [toContactsMapData, setToContactsMapData] = useState({});
    const [isRowEdit, setIsRowEdit] = useState(false);
    const [stepNameMap, setStepNameMap] = useState({});
    const [instanceMapList, setInstanceMapList] = useState([]);
    const [genericList, setGenericList] = useState([]);
    const [dashboardConfigData, setDashboardConfigData] = useState([]);
    const [page, setPage] = useState(0);
    const [newRowToSubmit, setNewRowToSubmit] = useState({
        dashboardConfigDataId: 0,
        genericName: "",
        instanceName: "",
        transaction: "",
        from: "",
        to: "",
        promiseTypes: "",
        exceptionTypes: "",
        timeRange: "",
        searchText: "",
        reportRecur: "",
    });
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [genericNames, setGenericNames] = useState([]);

    useEffect(() => {
        setShowLoader(true);
        http.sendRestRequest("documentChain/objects").then((response) => {
            let genericNames = [];
            let modalName = [];
            let instnaceName = [];
            const instanceMap = new Map();
            const stepsMap = new Map();
            const fromContactsMap = new Map();
            const toContactsMap = new Map();
            let stepNames = [];
            let genericObjList = [];
            let from = [];
            let to = [];
            let promiseType = [];
            let timeRange = [];

            response.forEach((gen) => {
                genericNames.push(gen.genericRegistry.genericDisplayName);
                genericObjList.push({
                    text: gen.genericRegistry.genericDisplayName,
                    id : gen.genericRegistry.genericId
                });
                modalName.push(gen.genericRegistry.genericDisplayName);
                instanceMap.set(
                    gen.genericRegistry.genericDisplayName,
                    gen.instances.map((instance) => {
                        return { text: instance.instanceName };
                    })
                );
                stepsMap.set(
                    gen.genericRegistry.genericDisplayName,
                    gen.stepNames.map((item) => {
                        return { text: item };
                    })
                );
                fromContactsMap.set(
                    gen.genericRegistry.genericDisplayName,
                    gen.fromContacts.map((item) => {
                        return { text: item };
                    })
                );
                toContactsMap.set(
                    gen.genericRegistry.genericDisplayName,
                    gen.toContacts.map((item) => {
                        return { text: item };
                    })
                );
                instnaceName.push(
                    ...gen.instances.map((item) => item.instanceName)
                );
                stepNames.push(gen.stepNames);
                from.push(gen.fromContacts);
                to.push(gen.toContacts);
            });
            setGenericNames(genericNames);
            setGenericList(genericObjList);
            setInstanceMapList(instanceMap);
            setStepNameMap(stepsMap);
            setFromContactsMapData(fromContactsMap);
            setToContactsMapData(toContactsMap);
            getDashboardConfigList();
        });
    }, []);
    const getDashboardConfigList = () => {
        setShowLoader(true);
        let url = "dashboardReport/ruleConfig/list";
        http.sendRestRequest(url, "GET").then((resp) => {
            setDashboardConfigData(resp);
            setShowLoader(false);
        });
    };
    const handleSwitchChange = async (e, rowId) => {
        try {
            const updatedData = dashboardConfigData.map((row) =>
                row.dashboardReportRuleId === rowId
                    ? { ...row, isActive: e.target.checked }
                    : row
            );
            setDashboardConfigData(updatedData);
            // Call API to update isActive status in the backend
            // await http.sendRestRequest(`dashboardReport/ruleConfig/${rowId}`, "PUT", { isActive: e.target.checked });
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };
    const handleSubmit = async (payload, isRowEdit) => {
        try {
            setShowLoader(true);
            if (!isRowEdit) {
                http.sendRestRequest(
                    "dashboardReport/ruleConfig",
                    "POST",
                    payload
                ).then((response) => {
                    setShowLoader(false);
                    getDashboardConfigList();
                    setSnackbarMessage("Dashboard Alert Created Successfully!");
                    setShowSnackbar(true);
                    setSeverity("success");
                    setSelectedRowData(null);
                    setIsRowEdit(false);
                });
            } else {
                http.sendRestRequest(
                    "dashboardReport/ruleConfig",
                    "PUT",
                    payload
                ).then((response) => {
                    setShowLoader(false);
                    getDashboardConfigList();
                    setSnackbarMessage("Dashboard Alert Updated Successfully!");
                    setShowSnackbar(true);
                    setSeverity("success");
                    setSelectedRowData(null);
                    setIsRowEdit(false);
                });
            }
        } catch (error) {
            setShowLoader(false);
            console.error("Error submitting data:", error);
        }
    };
    const handleOptionsClick = (event, row) => {
        setSelectedRowData(row);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (e) => {
        setAnchorEl(null);
    };
    const deleteClickHandler = (e) => {
        setAnchorEl(null);
        setAlertDialogContent({
            title: "Delete Alert",
            message: "Are you sure you want to Delete the selected Alert?",
            isAlert: true,
            buttonName: "Delete",
            buttonId: "btn_delete_generic",
        });
        setAlertDialogShow(true);
    };
    const showAlertView = (title, body, messageId, buttonId, isError) => {
        setAlertDialogContent({
            title: title,
            message: body,
            messageId: messageId,
            buttonId: buttonId,
        });
        isError ? setAlertDialogShow(true) : setShowSnackbar(true);
    };
    const handleConfirmationDialog = (response, action) => {
        setAlertDialogContent({
            title: "",
            message: "",
            isAlert: false,
        });
        if (response === "YES") {
            if (action === "DELETE") {
                setShowLoader(true);
                let url =
                    "dashboardReport/ruleConfig?dashboardReportRuleId=" +
                    selectedRowData.dashboardReportRuleId;
                http.sendRestRequest(url, "DELETE")
                    .then((resp) => {
                        if (resp === 200) {
                            setSnackbarMessage(
                                "Dashboard Alert Deleted successfully!"
                            );
                            setShowSnackbar(true);
                            setSeverity("success");
                            setShowLoader(false);
                            setSelectedRowData(null);
                            getDashboardConfigList();
                            setIsRowEdit(false);
                        } else {
                            showAlertView(
                                "Delete Item",
                                "Something went wrong, Please try again!"
                            );
                        }
                    })
                    .catch((err) => {
                        showAlertView(
                            "Operation Failed",
                            err.error,
                            "",
                            "",
                            true
                        );
                        setShowLoader(false);
                    });
            }
        }
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const onChange = (e, key, rowId) => {
        console.log(e.target, key, rowId);
        if (rowId) {
            let cellToSubmit = {};
            cellToSubmit["dashboardConfigDataId"] = rowId;
            cellToSubmit[key] = e.target.value;
            console.log(cellToSubmit);
        } else {
            let rowToSubmit = newRowToSubmit;
            rowToSubmit[key] = e.target.value;
            setNewRowToSubmit(rowToSubmit);
        }
    };
    const handleEdit = (row) => {
        let isEditAllowed = true;
        row.genericNames.forEach((name) => {
            if (!genericNames.includes(name)) {
                setShowSnackbar(true);
                setSeverity("error");
                setSnackbarMessage(
                    "Atleast one of the Generic Names is renamed or deleted."
                );
                isEditAllowed = false;
            }
        });
        if (isEditAllowed) {
            setSelectedRowData(row);
            setIsRowEdit(true);
            setEmailModal(true);
        }
    };
    const renderRows = (row, rowIndex) => {
        return (
            <TableRow key={rowIndex}>
                <TableCell>
                    <div
                        style={{ margin: "auto", cursor: "pointer" }}
                        id={"div_edit_" + rowIndex}
                        title="edit"
                    >
                        <img
                            src="./images/pencil-fill.svg"
                            alt="edit"
                            onClick={(e) => handleEdit(row)}
                        />
                    </div>
                </TableCell>
                {Object.keys(row)
                    .slice(1, 11)
                    .map((key, index) => (
                        <TableCell
                            key={index}
                            style={{
                                maxWidth: "12rem",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "20px",
                                letterSpacing: "-0.006em",
                                textAlign: "left",
                                color: "#4B5362",
                                cursor: "default",
                            }}
                        >
                            {key === "reportRecur" ? (
                                <div
                                    className="textEllipsis"
                                    style={{ width: "113px" }}
                                    title={
                                        row[key].split("|")[0] +
                                        "|" +
                                        convertUTCTimeToLocalTime(
                                            row[key].split("|")[1]
                                        )
                                    }
                                >
                                    {(() => {
                                        const rippleLogTitle =
                                            row[key].split("|")[0] +
                                            "|" +
                                            convertUTCTimeToLocalTime(
                                                row[key].split("|")[1]
                                            );
                                        return <span>{rippleLogTitle}</span>;
                                    })()}
                                </div>
                            ) : (
                                <div
                                    className="textEllipsis"
                                    style={{ width: "150px" }}
                                    title={
                                        Array.isArray(row[key]) &&
                                        row[key].join(", ")
                                    }
                                >
                                    {Array.isArray(row[key])
                                        ? row[key].join(", ")
                                        : row[key]}
                                </div>
                            )}
                        </TableCell>
                    ))}
                <TableCell>
                    <div
                        style={{ margin: "auto", cursor: "pointer" }}
                        id={"div_delete_" + rowIndex}
                        title="Option"
                    >
                        <img
                            src="./images/ellipsis.svg"
                            alt="option"
                            onClick={(event) => handleOptionsClick(event, row)}
                        />
                    </div>
                </TableCell>
            </TableRow>
        );
    };

    return (
        <>
            {dashboardConfigData.length > 0 ? (
                <>
                    <div
                        className="col-12 defaultScroller"
                        style={{
                            display: "flex",
                            flexDirection: "column",

                            padding: "0",
                        }}
                    >
                        <Paper
                            style={{
                                height: "calc(100% - 50px)",
                                position: "relative",
                            }}
                        >
                            <TableContainer
                                className="invisibleScroller spacelistTable"
                                style={{ padding: "0px", height: "100%" }}
                            >
                                <Table
                                    stickyHeader
                                    aria-label="sticky table"
                                    size="small"
                                >
                                    <TableHead
                                        className="table"
                                        style={{
                                            backgroundColor: "#EAEEF5",
                                            height: "56px",
                                            background: "#EAEEF5",
                                        }}
                                    >
                                        <TableRow>
                                            {[
                                                "Edit",
                                                "Generic Name",
                                                "Instance Name",
                                                "Step Name",
                                                "From",
                                                "To",
                                                "Promise Type",
                                                "Time Range",
                                                "Exception Type",
                                                "Search Text",
                                                "Report Recur",

                                                "Action",
                                            ].map((column, index) => (
                                                <TableCell
                                                    key={index}
                                                    title={column}
                                                    style={{
                                                        maxWidth: "12rem",
                                                        cursor: "default",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {column}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {dashboardConfigData
                                            .slice(
                                                page * rowsPerPage,
                                                page * rowsPerPage + rowsPerPage
                                            )
                                            .map((row, rowIndex) =>
                                                renderRows(row, rowIndex)
                                            )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={dashboardConfigData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            style={{
                                position: "absolute",
                                bottom: "0px",
                                right: "0px",
                            }}
                        />
                    </div>

                    <Menu
                        id="demo-customized-menu"
                        MenuListProps={{
                            "aria-labelledby": "demo-customized-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={deleteClickHandler} id="deleteGen">
                            <div>
                                <img
                                    className="deleteIcon"
                                    src="./images/delete.svg"
                                    alt="Delete"
                                    title="Delete"
                                />
                                <span className="btn_title" title="Delete">
                                    Delete
                                </span>
                            </div>
                        </MenuItem>
                    </Menu>
                    <AlertDialog
                        open={alertDialogShow}
                        setOpen={setAlertDialogShow}
                        title={alertDialogContent.title}
                        handleConfirmationDialog={handleConfirmationDialog}
                        message={alertDialogContent.message}
                        isAlert={alertDialogContent.isAlert}
                        messageId={alertDialogContent.messageId}
                        buttonId={alertDialogContent.buttonId}
                        buttonName={alertDialogContent.buttonName}
                    ></AlertDialog>

                    <CustomSnackbar
                        open={showSnackbar}
                        setOpen={setShowSnackbar}
                        alertMessage={snackbarMessage}
                        severity={severity}
                    ></CustomSnackbar>
                </>
            ) : (
                <EmptyConfigComponent
                    setEmailModal={setEmailModal}
                    value="You haven’t created any dashboard report emails yet"
                />
            )}
            <DashboardModal
                setSelectedRowData={setSelectedRowData}
                setIsRowEdit={setIsRowEdit}
                isRowEdit={isRowEdit}
                editRowData={selectedRowData}
                setEmailModal={setEmailModal}
                emailModal={emailModal}
                handleSubmit={handleSubmit}
                genericList={genericList}
                instanceMapList={instanceMapList}
                toContactsMapData={toContactsMapData}
                fromContactsMapData={fromContactsMapData}
                stepNameMap={stepNameMap}
            />
            <Loader show={showLoader}></Loader>
        </>
    );
}
